import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Col, Form, Row } from 'antd'

import {
  FormValues,
  useSendMailResetPassword,
} from './useSendMailResetPassword'
import { InputField } from 'src/components/form'
import ButtonCustom from 'src/components/form/Button'
import LPHeader from 'src/components/layout/Header/LPHeader'
import { useSearchParams } from 'react-router-dom'

const Container: React.FC = () => {
  const { form, onSubmit } = useSendMailResetPassword()
  const { control, handleSubmit, formState } = form

  const [searchParams] = useSearchParams()

  useEffect(() => {
    const mail = searchParams.get('email')
    if (mail) {
      form.setValue('email', mail)
    }
  }, [form, searchParams])

  return (
    <Wrapper>
      <LPHeader />
      <div className="page-title">
        <h5>パスワード再設定</h5>
        <p className="p-x">
          パスワードを再発行いたします。
          <br />
          ご登録のメールアドレスを入力してください。
          パスワード再設定用のURLを記載したメールをお送りします。
          <br />
          ※メールが届かない場合は、迷惑メールフォルダをご確認いただくか、メールアドレスが正しいか再度お確かめください。
        </p>
      </div>
      <StyleForm onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col xs={8}>
            <label>メールアドレス</label>
          </Col>
          <Col xs={24}>
            <InputField<FormValues>
              controller={{
                control,
                name: 'email',
              }}
              inputProps={{
                placeholder: '入力してください',
                type: 'email',
              }}
            />
          </Col>
        </Row>
        <ButtonCustom
          className="btn-default btn-gurkha mt-5 btn-submit"
          loading={formState.isSubmitting}
          onClick={handleSubmit(onSubmit)}
          htmlType="submit"
          showIconRight
          name="再設定メールを送信"
        />
      </StyleForm>
      {/* <Notification></Notification> */}
    </Wrapper>
  )
}

const StyleForm = styled(Form)`
  padding: 0 20px;
  & input {
    padding: 15px !important;
  }
  & .btn-submit {
    font-size: 18px;
  }
  & label {
    font-size: 15px !important;
    font-weight: 700;
    display: block;
    margin-bottom: 10px;
  }
`
const Wrapper = styled.div`
  & .page-title {
    margin-top: 75px;
    text-align: center;

    & h5 {
      margin-bottom: 40px;
    }
    & p {
      line-height: 24px;
      font-weight: 500;
      font-size: 13px;
      color: var(--color-kelp);
      margin-bottom: 70px;
    }

    & .p-x {
      padding: 0 55px;
    }
  }
`

export default Container
